import { Component, OnInit, Optional } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { DynamicFormsService } from '../../services/dynamic-forms/dynamic-forms.service';
import { FormInfoService } from '../../services/dynamic-forms/form-info.service';
import { ErrorService } from '../../services/form-utility/error.service';
import { DynamicFormLoadDirective } from '../../directives/dynamic-form-structural.directive';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss'],
})
export class TimeInputComponent extends BaseInputDirective implements OnInit {
  constructor(
    formInfoService: FormInfoService,
    dynamicFormsService: DynamicFormsService,
    errorService: ErrorService,
    @Optional()
    dynamicFormDirective: DynamicFormLoadDirective,
  ) {
    super(formInfoService, dynamicFormsService, errorService, dynamicFormDirective);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
